












import SocialMediaList from '@/components/SocialMediaList'
import DocumentLink from '@/components/DocumentLink'

export default {
    name: 'FooterSocialMediaList'

    components:
        DocumentLink: DocumentLink

    extends: SocialMediaList
}
